import { useState, useEffect } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange, Calendar } from 'react-date-range';
import Popover from '@mui/material/Popover';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { format } from 'date-fns';

import translator from '@Components/Utilities/Translator';
import TextField from '@Components/Shared/Controls/TextField'

const DateRangePicker = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [rangeLabel, setRangeLabel] = useState('Date From - Date To');
    const [rangeValue, setRangeValue] = useState();
    const [userSelectionMade, setUserSelectionMade] = useState(false);
    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
            key: 'selection'
        }]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (!props.departingDate) return;

        const startDate = new Date(props.departingDate);
        const endDate = props.returningDate ? new Date(props.returningDate) : null;

        setState([{
            startDate,
            endDate: endDate ?? startDate,
            key: 'selection'
        }]);

        if (props.isRoundTrip && endDate) {
            setRangeValue(`${format(startDate, 'PP')} - ${format(endDate, 'PP')}`);
        } else {
            setRangeValue(format(startDate, 'PP'));
        }
    }, [props.departingDate, props.returningDate]);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleDateRangeChange = (item) => {
        setUserSelectionMade(true);
        setState([item.selection]);
        setRangeValue(`${format(item.selection.startDate, 'PP')} - ${format(item.selection.endDate, 'PP')}`);        
        props.setDateRanges(item.selection.startDate, item.selection.endDate);

        if (item.selection.startDate && item.selection.endDate && (item.selection.startDate < item.selection.endDate)) {
            handleClose();
        }
    };

    const handleDateSelect = (date) => {
        setUserSelectionMade(true);
        props.setDateRanges(date, null);
        setRangeValue(format(date, 'PP'));
        setState([{ startDate: date, endDate: null, key: 'selection' }]);
        handleClose();
    }

    useEffect(() => {
        if (userSelectionMade) {
            let departDate = state[0]?.startDate ? format(state[0]?.startDate, 'PP') : '';
            let returnDate = state[0]?.endDate ? format(state[0]?.endDate, 'PP') : '';

            if (departDate) {
                if (props.isRoundTrip) {
                    setRangeLabel(translator.translate('Sandhills.tradesites.mvc.selectdates'));
                    setRangeValue(`${departDate} - ${returnDate}`);
                }
                else {
                    setRangeLabel(translator.translate('Sandhills.tradesites.mvc.departdate'));
                    setRangeValue(departDate)
                }
            }
        }

        else {
            if (props.isRoundTrip) {
                setRangeLabel(translator.translate('Sandhills.tradesites.mvc.selectdates'));
            }
            else {
                setRangeLabel(translator.translate('Sandhills.tradesites.mvc.departdate'));
            }
        }
    }, [props.isRoundTrip]);

    return (
        <>
            {props.isModal ? (
                <div style={{ position: 'relative' }}>
                    <TextField
                        id='DateRange'
                        name='DateRange'
                        onClick={handleClick}
                        label={rangeLabel}
                        value={rangeValue}
                        type='text'
                        class='input-container'
                        required={true}
                    />
                    <CalendarMonthIcon
                        className='material-icon'
                        style={{ position: 'absolute', right: '8px', top: '50%', pointerEvents: 'none', color: '#57595b', fontSize: '20px' }}
                    />
                </div>
            ) : (
                <>
                    <CalendarMonthIcon className='material-icon' />
                    <TextField
                        id='DateRange'
                        name='DateRange'
                        onClick={handleClick}
                        floatingLabel={rangeLabel}
                        value={rangeValue}
                        type='text'
                        class='input-container'
                            required={true}
                    />
                </>
            )}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                sx={{ zIndex: 99999 }}
            >
                {props.isRoundTrip ?
                    <DateRange
                        editableDateInputs={true}
                        onChange={handleDateRangeChange}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                        color='#333333'
                        rangeColors={['#333333']}
                        minDate={new Date()}
                    />
                    :
                    <Calendar
                        id={id}
                        name='SingleDatePicker'
                        date={props.departingDate}
                        onChange={handleDateSelect}
                        inputFormat='MM/dd/yyyy'
                        color='#333333'
                        minDate={new Date()}
                    />
                }
            </Popover>
        </>
    );
};

export default DateRangePicker;